import { useAuthContext } from "lib/contexts/AuthProvider";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { usePopupOrchestrator } from "lib/contexts/PopupOrchestratorProvider";
import { useUserContext } from "lib/contexts/UserProvider";
import { resolveAutoTriggerConfig } from "lib/constants/popupConfig";
import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const PopupLoadPhaseGate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page")?.toLowerCase();
  const isCartPage = page === "cart";
  const isEmptyCartPage = page === "empty-cart";

  const {
    state: { checkoutLoading, checkoutId },
  } = useCheckoutContext();
  const {
    state: { checkoutMetadata, cartMetadata },
  } = useMerchantContext();
  const {
    state: { isAuthenticated },
  } = useAuthContext();
  const {
    state: { isAddressLoading },
  } = useUserContext();
  const { completeLoadPhase, setAutoTriggerConfig } = usePopupOrchestrator();

  const isAddressReady = !isAuthenticated || !isAddressLoading;

  const isLoadPhaseReady = isEmptyCartPage
    ? true
    : isCartPage
    ? Boolean(checkoutId) && !cartMetadata?.metadataLoading
    : !checkoutLoading && isAddressReady && !checkoutMetadata?.metadataLoading;

  const dialogs = isCartPage
    ? cartMetadata?.uiAttributes?.dialogConfig?.dialogs
    : checkoutMetadata?.uiAttributes?.dialogConfig?.dialogs;

  const autoTriggerConfig = useMemo(() => resolveAutoTriggerConfig(dialogs), [dialogs]);

  const isMetadataLoaded = isCartPage
    ? !cartMetadata?.metadataLoading
    : !checkoutMetadata?.metadataLoading;

  useEffect(() => {
    if (isMetadataLoaded) {
      setAutoTriggerConfig(autoTriggerConfig);
    }
  }, [isMetadataLoaded, autoTriggerConfig, setAutoTriggerConfig]);

  useEffect(() => {
    if (isLoadPhaseReady) {
      completeLoadPhase();
    }
  }, [isLoadPhaseReady, completeLoadPhase]);

  return null;
};

export default PopupLoadPhaseGate;